module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', [(_vm.large) ? _c('b-col', [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("badges")], 2) : _c('b-col', [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _vm._t("badges")], 2), _vm._v(" "), _c('b-col'), _vm._v(" "), _c('b-col', [_c('a', {
    attrs: {
      "href": _vm.contextPath
    }
  }, [_c('b-img', {
    staticClass: "context-help-header",
    attrs: {
      "right": "",
      "src": require("@/assets/images/question-mark.svg")
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-495033fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/context-header/ContextHeader.vue
// module id = 761
// module chunks = 1